import React from 'react';
import { FmlxSwitch } from 'fmlx-common-ui';

interface Props {
  total: number;
  fetchedRecords: number;
  showDistinctRows: boolean;
  onChangeDistinctRow: () => void;
}

export const SearchCustomFooterView = (props: Props) => {
  const { total, fetchedRecords, showDistinctRows, onChangeDistinctRow } = props;

  return (
    <div className="basis-11/12 flex flex-row items-center gap-6">
      <div className="flex-1 flex flex-row gap-4 items-center">
        <div>
          Total Records: {total >= 0 ? total : <span className="loading-dots">...</span>}
        </div>
        <div>Fetched Records: {fetchedRecords}</div>
      </div>
      <div className="flex flex-row items-center gap-2 mr-8">
        <label className="m-0 p-1">Show Distinct Rows Only</label>
        <FmlxSwitch size="sm" checked={showDistinctRows} onChange={onChangeDistinctRow} />
      </div>
    </div>
  );
};
